import { useState } from "react";
import AppInputNew from "@/components/Core/AppInput/AppInputNew";
import Button from "@/components/Core/Button/Button";
import { useOrganisation, useUpdateOrganisation } from "@/networking/organisation.hooks";
import { SettingsLeaf } from "./SettingsLeafLayout";

const KontaktuppgifterPage = () => {
	const { data: organisation } = useOrganisation();
	const { mutate: updateOrganisation } = useUpdateOrganisation();

	const [website, setWebsite] = useState(organisation?.contact?.website || "");
	const [openHours, setOpenHours] = useState(organisation?.contact?.openHours || "");
	const [email, setEmail] = useState(organisation?.contact?.email || "");
	const [phone, setPhone] = useState(organisation?.contact?.phone || "");

	function save() {
		updateOrganisation({
			contact: {
				website: website && !website.includes("http") ? "https://" + website : website,
				email,
				phone,
				openHours,
			},
		});
	}

	return (
		<SettingsLeaf
			title="Kontaktuppgifter"
			description="Kontaktuppgifter som visas för konsult och kund och används vid bokning och support."
		>
			<AppInputNew label="Öppettider" value={openHours} onChangeText={setOpenHours} />
			<AppInputNew label="Telefonnummer" value={phone} onChangeText={setPhone} />
			<AppInputNew label="Webbsida" value={website} onChangeText={setWebsite} />
			<AppInputNew label="E-post" value={email} onChangeText={setEmail} />
			<div>
				<Button onClick={save}>Uppdatera</Button>
			</div>
		</SettingsLeaf>
	);
};

export default KontaktuppgifterPage;
